export default __webpack_public_path__ + "static/media/loading.826ae85e.gif";